export default "__VITE_ASSET__b4d0c1dd__"